import { SyntheticEvent, useCallback, useEffect, useState } from "react";
import { useUserContext } from "../contexts";
import { Box, Tabs, Tab } from "@mui/material";
import {
	DoctorStatus,
	Membership,
	MobileCheckIn
} from "../components/CentreOperations";
import { BannedPatients } from "../components/BannedPatients";
import { ADMIN, EXECUTIVE_CENTRE_ADMIN, CENTRE_ADMIN } from "../constants";
import { useLocation } from "react-router-dom";
import { Clinic } from "../models";

export const CentreOperations = () => {
	const { user } = useUserContext();
	const { state } = useLocation();
	const [tabIndex, setTabIndex] = useState(0);
	const [hasAccessAllTabs, setHasAccessAllTabs] = useState(false);
	const [displayNoAccess, setDisplayNoAccess] = useState(false);
	const [clinic, setClinic] = useState<Clinic | undefined>(undefined);

	useEffect(() => {
		if (user && user.roles.length > 0) {
			if (
				user.roles.some((role) =>
					[ADMIN, EXECUTIVE_CENTRE_ADMIN, CENTRE_ADMIN].includes(role)
				)
			) {
				setHasAccessAllTabs(true);
			}
		}
	}, [user]);

	const handleTabChange = useCallback(
		(event: SyntheticEvent, newValue: number) => {
			console.info("handleTabChange", newValue);
			if ([0, 3].includes(newValue) || hasAccessAllTabs) {
				setDisplayNoAccess(false);
			} else {
				setDisplayNoAccess(true);
			}
			setTabIndex(newValue);
		},
		[hasAccessAllTabs]
	);

	useEffect(() => {
		console.info("centreOperations state", state);
		if (state?.tabOption != null) {
			handleTabChange({} as unknown as SyntheticEvent, state?.tabOption);
		}
		if (state?.clinic != null) {
			setClinic(state?.clinic);
		}
	}, [handleTabChange, state, setClinic]);

	return (
		<>
			<Box
				sx={{
					borderBottom: 1,
					borderColor: "divider",
					marginBottom: 4,
					width: "fit-content"
				}}
			>
				<Tabs
					value={tabIndex}
					onChange={handleTabChange}
					aria-label="Centre Operations tabs"
				>
					<Tab label="Doctor Status" />
					<Tab label="Mobile Check In" />
					<Tab label="Membership" />
					<Tab label="Banned Patients" />
				</Tabs>
			</Box>
			{displayNoAccess ? (
				<div className="flex ">You do not have permission for this feature</div>
			) : (
				<>
					{tabIndex === 0 && (
						<DoctorStatus clinic={clinic} setClinic={setClinic} />
					)}
					{tabIndex === 1 && <MobileCheckIn />}
					{tabIndex === 2 && <Membership />}
					{tabIndex === 3 && (
						<BannedPatients clinic={clinic} setClinic={setClinic} />
					)}
				</>
			)}
		</>
	);
};
